import { Fragment, useState } from "react";
import Http from "../../../../Utils/Http";
import Notifier from "../../../../Utils/Notifier";

import Template, { Input } from "../../../../Utils/Template";

export default function ContinueRegistration() {

  const [codeRequest, setCodeRequest] = useState({email: localStorage.getItem('REGISTER_PARAMS_EMAIL')});

  const handleChange = e =>{
    setCodeRequest({...codeRequest, [e.target.name]: e.target.value});
  }

  const resendCode = async () => {
    let body = {...codeRequest};
    const response = await Http.request({uri: '/auth/register/send-code', body});
    if (response.notification) {
      Notifier(response.notification);
    }
    if ( response.result === 'success' ) {
      localStorage.setItem('REGISTER_PARAMS_EMAIL', codeRequest.email);
      sessionStorage.removeItem('PENDING_LOGIN_PASSWORD');
      window.location.replace('/auth/register/confirm');
    }
  }

  return (
    <Fragment>
      <div className="flex min-h-full text-poppins">
        <div className="w-full py-12 px-4 sm:px-6 lg:flex-col lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">Get Confirmation Code</h2>
              <p className="mt-2 text-sm">
              Use this page if you've registered or changd your email and did not receive a code, or you received a code and it expired.
              </p>
              <br />
              <p className="mt-2 text-sm">
              NB: For your online safety, we did not send you a link, and we will never send you a link by email or SMS.
              </p>
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      Email address
                    </label>
                    <div className="mt-1">
                      <input 
                        id="email" 
                        name="email" 
                        type="email"
                        value={codeRequest.email} 
                        required={true} 
                        autoComplete="email"
                        onChange={e => handleChange(e)}
                        className='bg-gray-300 w-full px-5 py-2 mt-5 focus:bg-gray-400 focus:outline-none active:outline-none'
                      />
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md border border-transparent bg-rfs-green-009933 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => resendCode()}
                    >
                      Resend Code
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );

}